if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        const spinner = this.querySelector(".loading-overlay__spinner");
        if (spinner) spinner.classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          /************************************************************/
          $("#cus-edi-for-op input").each(function () {
            if ($(this).attr("name")) {
              var name = $(this).attr("name");
              var value = $(this).val();

              formData.append(name, value);
            }
          });

          $("#cus-edi-for-op select").each(function () {
            if ($(this).attr("name")) {
              var name = $(this).attr("name");
              var value = $(this).val();

              formData.append(name, value);
            }
          });

          $("#cus-edi-for-op textarea").each(function () {
            if ($(this).attr("name")) {
              var name = $(this).attr("name");
              var value = $(this).val();

              formData.append(name, value);
            }
          });

          //swatch override
          $(".image-radio-checked input").each(function () {
            if ($(this).attr("name")) {
              var name = $(this).attr("name");
              var value = $(this).val();

              formData.append(name, value);
            }
          });
          /************************************************************/

          // AlpenWerk: Konfigurator-Properties kommen aus den hidden form inputs
          // (properties[Ausschnitt], properties[Ausrichtung], properties[_config_id])
          // Diese sind bereits im FormData via form="..." Attribut enthalten.
          // Der ATC-Interceptor aktualisiert sie vor dem re-submit.

          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const engravingEnabled =
          document.getElementById("enable_engraving")?.checked;
        const engravingProductId = document.querySelector(
          "#engraving_product [name='id']"
        )?.value;
        const engravingText = document.getElementById("engraving_text")?.value;
        const forProduct = document.querySelector(
          "#engraving_product [name='properties[Für Produkt]']"
        )?.value;

        if (engravingEnabled) {
          if (engravingText == "") {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            const sp2 = this.querySelector(".loading-overlay__spinner");
            if (sp2) sp2.classList.add("hidden");
            return alert("Please add the engraving text");
          }

          const formData = new FormData(this.form);
          const qty =
            parseInt(document.querySelector("[name='quantity']").value) || 1;
          const items = [];

          const engravingProduct = {
            id: engravingProductId,
            quantity: qty,
            properties: {
              "Gewünschter Text": engravingText,
              "Für Produkt": forProduct,
            },
          };

          items.push(engravingProduct);
          
          // Main product details
          const mainProduct = {
            id: formData.get("id"),
            quantity: qty,
            properties: {
              "Gewünschter Text": engravingText,
            },
          };

          // Collect additional properties for the main product
          formData.forEach((value, key) => {
            if (key.startsWith("properties[")) {
              mainProduct.properties[
                key.replace("properties[", "").replace("]", "")
              ] = value;
            }
          });

          items.push(mainProduct);

          const payload = {
            items,
            sections: this.cart
              .getSectionsToRender()
              .map((section) => section.id),
            sections_url: window.location.pathname,
            "product-id": formData.get("product-id"),
            "section-id": formData.get("section-id"),
          };

          config.body = JSON.stringify(payload);
          config.headers["Content-Type"] = "application/json";
        }
        console.log(config);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: "product-form" });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            const sp = this.querySelector(".loading-overlay__spinner");
            if (sp) sp.classList.add("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
